import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export type SelecetedDateReducerState = Date | null;

export const selectedDateReducerInitialState: SelecetedDateReducerState = null;

export enum selecetedDateActionTypes {
  SELECTED_DATE_UPDATE = 'SELECTED_DATE_UPDATE',
}

export interface SelectedDateReducerAction {
  type: selecetedDateActionTypes | selecetedShopIdActionTypes;
  payload: Date;
}

const selecetedDateReducer = (
  state: SelecetedDateReducerState,
  action: SelectedDateReducerAction
): SelecetedDateReducerState => {
  switch (action.type) {
    case selecetedDateActionTypes.SELECTED_DATE_UPDATE: {
      return action.payload;
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return null;
    }
    default:
      return state;
  }
};

export default selecetedDateReducer;
